type ViewerShortcutAction =
  | "open-sheet-search"
  | "toggle-maximized"
  | "toggle-sheet-switcher";

// Keep the matcher usable with plain test objects instead of requiring a full
// browser KeyboardEvent.
type ViewerShortcutEvent = Pick<
  KeyboardEvent,
  "key" | "metaKey" | "ctrlKey" | "altKey" | "shiftKey" | "defaultPrevented"
>;

interface ResolveViewerShortcutParams {
  canOpenSheetSearch: boolean;
  isViewerActive: boolean;
}

export const resolveViewerShortcut = (
  event: ViewerShortcutEvent,
  { canOpenSheetSearch, isViewerActive }: ResolveViewerShortcutParams,
): ViewerShortcutAction | null => {
  if (
    event.defaultPrevented ||
    event.altKey ||
    (!event.metaKey && !event.ctrlKey)
  ) {
    return null;
  }

  const key = event.key.toLowerCase();

  if (key === "f" && !event.shiftKey) {
    return canOpenSheetSearch ? "open-sheet-search" : null;
  }

  if (!isViewerActive) return null;
  if (key === "f" && event.shiftKey) return "toggle-maximized";
  if (key === "k") return "toggle-sheet-switcher";

  return null;
};
